/**
 * SP用の横スクロールカルーセル。
 * ネイティブのスクロールをそのまま使い、インジケーターのつまみと
 * 前後ボタンの表示だけをスクロール量から算出する。
 * スクロールの余地がない場合（カードが1枚、PC表示など）は一式を隠す。
 */
var cardCarousel = {
  init: function () {
    var roots = document.querySelectorAll('.js-card-carousel')
    if (!roots.length) return

    Array.prototype.forEach.call(roots, function (root) {
      cardCarousel.setup(root)
    })
  },

  setup: function (root) {
    var viewport = root.querySelector('.js-card-carousel-viewport')
    var indicator = root.querySelector('.js-card-carousel-indicator')
    var bar = root.querySelector('.js-card-carousel-bar')
    var prev = root.querySelector('.js-card-carousel-prev')
    var next = root.querySelector('.js-card-carousel-next')
    if (!viewport) return

    var update = function () {
      var max = viewport.scrollWidth - viewport.clientWidth
      var scrollable = max > 1

      if (indicator) indicator.classList.toggle('_hidden', !scrollable)
      if (prev) prev.classList.toggle('_hidden', !scrollable || viewport.scrollLeft <= 1)
      if (next) next.classList.toggle('_hidden', !scrollable || viewport.scrollLeft >= max - 1)

      if (bar && scrollable) {
        var ratio = viewport.clientWidth / viewport.scrollWidth
        bar.style.width = ratio * 100 + '%'
        bar.style.left = (viewport.scrollLeft / viewport.scrollWidth) * 100 + '%'
      }
    }

    // カード1枚ぶん＋gapを1ステップとして送る
    var step = function () {
      var card = viewport.querySelector('.p-inquiry-card')
      if (!card) return viewport.clientWidth
      var track = card.parentNode
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0
      return card.getBoundingClientRect().width + gap
    }

    var scrollBy = function (direction) {
      var left = viewport.scrollLeft + step() * direction
      if (viewport.scrollTo) {
        viewport.scrollTo({ left: left, behavior: 'smooth' })
      } else {
        viewport.scrollLeft = left
      }
    }

    if (prev) {
      prev.addEventListener('click', function () {
        scrollBy(-1)
      })
    }
    if (next) {
      next.addEventListener('click', function () {
        scrollBy(1)
      })
    }

    viewport.addEventListener('scroll', update)
    window.addEventListener('resize', update)
    update()
  },
}

export default cardCarousel
